import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState } from "react";
import { isValidPhoneNumber } from "react-phone-number-input";
import { isEmpty } from "./PhoneNumberInputUtilities";
export var usePhoneNumberInputValidation = function usePhoneNumberInputValidation(errors, required) {
  var _useState = useState(errors.phoneNumberMissing),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isError = _useState4[0],
      setIsError = _useState4[1];
  /* It should be React.FocusEventHandler<HTMLInputElement> */


  var validateOnBlur = function validateOnBlur(event) {
    var value = event.target.value;

    if (!required && isEmpty(value)) {
      return;
    }

    if (isEmpty(value)) {
      setIsError(true);
      setErrorMessage(errors.phoneNumberMissing);
      return;
    }

    if (!isValidPhoneNumber(value)) {
      setIsError(true);
      setErrorMessage(errors.invalidPhoneNumber);
    }
  };

  var validateOnChange = function validateOnChange() {
    setIsError(false);
  };
  /* To run validation check when component/Form field mounts*/


  var validateOnMount = function validateOnMount(value) {
    if (!required && isEmpty(value)) {
      return;
    }

    if (isEmpty(value)) {
      setIsError(true);
      setErrorMessage(errors.phoneNumberMissing);
      return;
    }

    if (!isValidPhoneNumber(value)) {
      setIsError(true);
      setErrorMessage(errors.invalidPhoneNumber);
    }
  };

  return {
    errorMessage: errorMessage,
    isError: isError,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  };
};